import React from "react"
import { useSelector } from "react-redux"
import { resolutionSet } from "reduxSlices/formSubmissionResolutionSlice"
import { formSubmissionClosed } from "reduxSlices/formSubmissionSlice"
import StrikeAround from "shared/StrikeAround"
import AddResolution from "./AddResolution"
import Resolution from "./Resolution"

const ResolutionSection = () => {
  const formSubmissionIsClosed = useSelector(formSubmissionClosed)
  const formSubmissionHasResolution = useSelector(resolutionSet)

  return (
    <div>
      <StrikeAround className="mb-6">
        <h3>Form Submission Resolution</h3>
      </StrikeAround>
      <div className="flex flex-col gap-4">
        <Resolution />
        {
          !formSubmissionHasResolution && !formSubmissionIsClosed && (
            <AddResolution buttonClassName="w-fit" />
          )
        }
      </div>
    </div>
  )
}

export default ResolutionSection
